function initProductGallery(container) {
  const mainEl = container.querySelector("#main-carousel");
  const thumbEl = container.querySelector("#thumbnail-carousel");

  if (!mainEl || !thumbEl) return;

  // Prevent duplicate init
  if (
    mainEl.classList.contains("splide-initialized") ||
    thumbEl.classList.contains("splide-initialized")
  ) {
    return;
  }

  var mainCarousel = new Splide(mainEl, {
    type: "fade",
    rewind: true,
    pagination: false,
    arrows: false,
  });

  var thumbnailsCarousel = new Splide(thumbEl, {
    fixedWidth: 120,
    fixedHeight: 120,
    gap: 10,
    rewind: true,
    pagination: false,
    isNavigation: true,
    direction: "ttb",
    height: "490px",
    arrows: false,
    breakpoints: {
      767: {
        fixedWidth: 60,
        fixedHeight: 60,
        gap: 10,
        height: "auto",
        direction: "ltr",
        arrows: false,
      },
    },
  });

  mainCarousel.sync(thumbnailsCarousel);
  mainCarousel.mount();
  thumbnailsCarousel.mount();

  mainEl.classList.add("splide-initialized");
  thumbEl.classList.add("splide-initialized");
}

function initTestimonialsSlider(container) {
  // container may be the slider element itself or a parent container
  const el = container.querySelector(".testimonials-slider") || container;
  if (!el) return;

  // Prevent duplicate mount if already initialized
  if (el.classList.contains("splide-initialized")) return;

  new Splide(el, {
    perPage: 3,
    gap: "29px",
    arrows: false,
    pagination: true,
    drag: true,
    breakpoints: {
      1150: { perPage: 2.5, gap: "10px" },
      940: { perPage: 2, gap: "10px" },
      480: { perPage: 1, gap: "10px", drag: true, padding: { right: "20px" } },
    },
  }).mount();

  el.classList.add("splide-initialized");
}

function initReviewSlider(container) {
  // container may be the slider element itself or a parent container
  const el = container.querySelector(".review-slider") || container;
  if (!el) return;

  // Prevent duplicate mount
  if (el.classList.contains("splide-initialized")) return;

  new Splide(el, {
    perPage: 3,
    gap: "29px",
    arrows: false,
    pagination: true,
    breakpoints: {
      1150: { perPage: 2.5, gap: "10px" },
      940: { perPage: 2, gap: "10px" },
      480: { perPage: 1, gap: "10px" },
    },
  }).mount();

  el.classList.add("splide-initialized");
}

// Unified initializer: used on initial load and when Shopify customizer reloads sections
function initAllWithin(root = document) {
  // product galleries
  root
    .querySelectorAll("[data-product-gallery]")
    .forEach((container) => initProductGallery(container));

  // testimonials sliders
  root
    .querySelectorAll(".testimonials-slider")
    .forEach((el) => initTestimonialsSlider(el));

  // review sliders
  root.querySelectorAll(".review-slider").forEach((el) => initReviewSlider(el));
}

// Init on page load (single listener)
document.addEventListener("DOMContentLoaded", () => {
  initAllWithin(document);
});

// Init when Shopify Customizer reloads sections (single listener)
// event.target will be the root container for the reloaded section
document.addEventListener("shopify:section:load", (event) => {
  if (event && event.target) {
    initAllWithin(event.target);
  }
});

// theme.js

function initSmoothScroll(container) {
  const anchors = container.querySelectorAll('a[href^="#"]');
  if (!anchors.length) return;

  anchors.forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetID = this.getAttribute("href");
      const targetElement = document.querySelector(targetID);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop + 0, // adjust for sticky header if needed
          behavior: "smooth",
        });
      }
    });
  });
}

// Init on page load
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("body").forEach(initSmoothScroll);
});

// Init when Shopify Customizer reloads sections
document.addEventListener("shopify:section:load", (event) => {
  initSmoothScroll(event.target);
});
